import React from 'react';
import { useSelector } from 'react-redux';
import { DarkmodeColors } from 'app/constants/color';

const NotFound = () => {
  const { darkmode } = useSelector(state => state.dark);
  return (
    <div
      style={{
        textAlign: 'center',
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: darkmode && DarkmodeColors.appBar,
      }}
    >
      <img
        src={darkmode ? '/assets/images/404lightmode.svg' : '/assets/images/404.svg'}
        alt=''
        style={{ width: '50%' }}
      />
      {/* <h1 style={{ fontSize: '5em' }}>404</h1>
      <h2 style={{ marginBottom: '50px' }}>Page Not Found</h2>
      <p>The page you are looking for could not be found.</p> */}
    </div>
  );
};

export default NotFound;
